<app-layout>
  <div class="row">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Ürün Grupları</h3>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="new()">Yeni Ürün Grubu</div>
          </div>
        </div>
        <app-urun-grup-liste [source]="urunGruplar" (view)="incele($event)"
                             (delete)="kaldir($event)"></app-urun-grup-liste>
      </div>
    </div>
  </div>
</app-layout>
